import React from "react";
import { TYPE, G } from "../../constants/theme";

export default function SectionTitle({ children, light = false, style = {} }) {
  return (
    <h2
      style={{
        ...TYPE.sectionTitle,
        color: light ? G.white : G.gray900,
        margin: 0,
        ...style,
      }}
    >
      {children}
    </h2>
  );
}
